import React from "react";
import "./experience.css";
import Button from "../common/Button";

const Experience = () => {
  return (
    <div className="experience photo-section">
      <div className="max-width">
        <div className="photo-section-child">
          <div className="photo-section-top">
            <div className="photo-section-heading experience-heading">
            we handle your investments seriously.
            </div>
            <div className="photo-section-subheading">
            so you don’t have to.
            </div>
          </div>
          <div className="photo-section-bottom">
            <div className="photo-section-desc experience-desc">
            our AI tracks markets non-stop, helps you invest on time,
            and gives clear insights so you always know where your money goes.
            </div>
            <div>
              <Button buttonText="Experience the upgrade" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
